import { readItem } from "./safeStorage";

// Storage keys, shared with the popup component that writes them.
export const LS_DISMISSED_AT = "popupDismissedAt";
export const LS_SUBMITTED = "popupSubmitted";
export const SS_SHOWN_SESSION = "popupShownSession";

const DISMISS_COOLDOWN_DAYS = 7;
export const DISMISS_COOLDOWN_MS = DISMISS_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;

/**
 * Why the brochure popup is not firing, or null when it should.
 *
 * Its own module so the decision can be tested without rendering anything,
 * and because `enabled` now sits in front of every other reason. The popup is
 * behind a setting an operator flips from Setări curs, no redeploy: it
 * interrupts a reader mid-page to offer a brochure, and while the site is
 * judged on enrolments rather than on addresses collected, that interruption
 * can cost more than it brings in.
 *
 * `enabled` defaults to true so no caller loses the popup by forgetting the
 * argument — the off switch has to be asked for.
 */
export function shouldSuppress(pathname, enabled = true) {
  if (!enabled) return "disabled";
  if (pathname && pathname.startsWith("/checkout")) return "checkout";
  if (pathname && pathname.startsWith("/admin")) return "admin";
  if (readItem("local", LS_SUBMITTED) === "1") return "submitted";
  const dismissedAt = Number(readItem("local", LS_DISMISSED_AT) || 0);
  if (dismissedAt && Date.now() - dismissedAt < DISMISS_COOLDOWN_MS) return "cooldown";
  if (readItem("session", SS_SHOWN_SESSION) === "1") return "session";
  return null;
}
